import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  isMaximized: true,
  podcast: null,
  watchType: "watch",
  episodes: null,
  media: null,
  progressData: {},
};

const slice = createSlice({
  name: "media",
  initialState,
  reducers: {
    setMaximized: (state, action) => {
      state.isMaximized = action.payload;
    },
    setWatchType: (state, action) => {
      state.watchType = action.payload;
      if (state.watchType === "listen") {
        state.isMaximized = false;
      }
    },
    setEpisodes: (state, action) => {
      state.episodes = action.payload;
    },
    setMedia: (state, action) => {
      state.media = action.payload;
    },
    setPodcast: (state, action) => {
      state.podcast = action.payload;
    },
    setProgress: (state, action) => {
      if (!state.progressData) state.progressData = {};
      state.progressData[action.payload.id] = action.payload.progress;
    },
  },
});

export default slice.reducer;
export const {
  setMaximized,
  setWatchType,
  setEpisodes,
  setMedia,
  setPodcast,
  setProgress,
} = slice.actions;

export const getIsMaximized = (state) => {
  if (state.media.watchType === "listen") return false;
  return state.media.isMaximized;
};
export const getWatchType = (state) => state.media.watchType;
export const getEpisodes = (state) => state.media.episodes;
export const getMedia = (state) => state.media.media;
export const getPodcast = (state) => state.media.podcast;
export const getProgressData = (state) => state.media.progressData;
